import { useRef } from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

import { inputSearch } from "_constants";
import { useAppDispatch } from "store/store";
import { setFilterSource } from "store/slicer/GestioneDetailProjectSlice";

export const InputSearchSourceProject = () => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: any) => {
    dispatch(setFilterSource(inputRef.current?.value));
  };

  return (
    <IconField iconPosition="left" className="container-input-custom">
      <InputIcon className="cta pi pi-search"></InputIcon>
      <InputText
        ref={inputRef}
        v-model="value1"
        placeholder={inputSearch}
        onKeyUp={handleChange}
        className="width-100 custom-input"
      />
    </IconField>
  );
};
